export default __webpack_public_path__ + "static/media/free.4aeb5a42.png";